import { useScrollReveal } from '@/hooks/useScrollReveal';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { FAQ_ITEMS } from '@/data/faqItems';

export default function FAQSection() {
  const titleRef = useScrollReveal();

  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32">
      <div className="container mx-auto px-6 md:px-12 max-w-4xl">
        <div ref={titleRef} className="scroll-reveal text-center mb-12 md:mb-16">
          <p className="text-sm font-semibold tracking-[0.2em] uppercase text-[hsl(211,100%,50%)] dark:text-[hsl(211,100%,55%)] mb-4">
            FAQ
          </p>
          <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-foreground mb-6">
            Questions frequentes sur l'automatisation IA
          </h2>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
            Les reponses aux questions les plus courantes pour choisir la bonne strategie IA.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full rounded-2xl border border-border/50 bg-card px-6 md:px-8">
          {FAQ_ITEMS.map((item, index) => (
            <AccordionItem key={item.question} value={`faq-${index}`}>
              <AccordionTrigger className="text-left text-foreground text-base md:text-lg font-medium py-5">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-sm md:text-base text-muted-foreground leading-relaxed pb-5">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
